var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6275_23317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1498 15.3245L10.8605 59.972C5.49472 66.0695 4.56985 63.731 2.41947 61.5806C0.269471 59.4306 -2.0694 58.5056 4.0281 53.1396L48.6756 13.8502C51.0577 11.7536 52.2465 12.9424 50.1498 15.3245Z",
    fill: "url(#paint0_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4 29.8122L50.15 15.3247C52.2463 12.9426 51.0575 11.7538 48.675 13.8497L34.1875 26.5997L37.4 29.8122Z",
    fill: "url(#paint1_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.714 40.2148L4.02823 53.1382C-2.06927 58.504 0.26923 59.4288 2.41961 61.5792C4.56961 63.7292 5.49461 66.0681 10.8606 59.9706L23.784 45.2848L18.714 40.2148Z",
    fill: "url(#paint2_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78516 49.832L14.1667 56.2135L23.7838 45.2848L18.7138 40.2148L7.78516 49.832Z",
    fill: "url(#paint3_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3794 44.1137L19.8825 39.6169C19.1556 38.89 17.9772 38.89 17.2503 39.6169C16.5235 40.3437 16.5235 41.5222 17.2503 42.249L21.7472 46.7459C22.4741 47.4727 23.6525 47.4727 24.3794 46.7459C25.1062 46.019 25.1062 44.8406 24.3794 44.1137Z",
    fill: "url(#paint4_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2217 5.24469L58.9278 12.0091C58.8265 12.3079 58.7993 12.6268 58.8487 12.9385C58.8981 13.2501 59.0225 13.5451 59.2112 13.7979L63.4831 19.5229C63.7001 19.814 63.8314 20.16 63.8621 20.5217C63.8928 20.8835 63.8217 21.2466 63.6568 21.5701C63.492 21.8936 63.2399 22.1645 62.9291 22.3522C62.6183 22.5399 62.2612 22.6369 61.8982 22.6323L54.7561 22.5409C54.4405 22.5369 54.1288 22.6097 53.8476 22.753C53.5665 22.8962 53.3244 23.1057 53.1422 23.3633L49.0181 29.1951C48.8084 29.4916 48.5199 29.7235 48.1853 29.8646C47.8507 30.0057 47.4833 30.0504 47.1247 29.9936C46.766 29.9368 46.4304 29.7807 46.1558 29.5431C45.8811 29.3055 45.6785 28.9958 45.5707 28.6491L43.4504 21.8282C43.3568 21.5269 43.1913 21.2529 42.9682 21.0298C42.7451 20.8067 42.4711 20.6412 42.1698 20.5476L35.3489 18.4273C35.0022 18.3195 34.6925 18.1169 34.4549 17.8422C34.2173 17.5676 34.0612 17.232 34.0044 16.8733C33.9476 16.5147 33.9923 16.1473 34.1334 15.8127C34.2745 15.4781 34.5064 15.1896 34.8029 14.9799L40.6357 10.8558C40.8933 10.6736 41.1028 10.4315 41.246 10.1504C41.3893 9.86922 41.4621 9.55746 41.4581 9.24194L41.3661 2.10019C41.3614 1.73707 41.4584 1.37987 41.6461 1.069C41.8338 0.758129 42.1048 0.505989 42.4284 0.341093C42.7519 0.176197 43.1152 0.105125 43.477 0.135914C43.8389 0.166703 44.1849 0.298125 44.4759 0.515317L50.2009 4.78719C50.4538 4.9759 50.7488 5.1003 51.0604 5.14966C51.372 5.19903 51.691 5.17189 51.9898 5.07057L58.7542 2.77669C59.0981 2.66021 59.4676 2.64224 59.8212 2.72481C60.1747 2.80739 60.4981 2.98721 60.7548 3.24396C61.0115 3.50071 61.1913 3.82414 61.2738 4.1777C61.3563 4.53126 61.3382 4.90085 61.2217 5.24469Z",
    fill: "url(#paint5_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.779 20.7959C46.5177 19.9555 46.056 19.1912 45.4337 18.5689C44.8113 17.9465 44.047 17.4848 43.2066 17.2236L42.0785 16.8728C41.828 16.795 41.6042 16.6486 41.4326 16.4502C41.2609 16.2518 41.1482 16.0093 41.1072 15.7502C41.0661 15.4911 41.0984 15.2257 41.2003 14.984C41.3023 14.7423 41.4698 14.5339 41.684 14.3824L42.6485 13.7004C43.3671 13.1923 43.9514 12.5169 44.351 11.7327C44.7506 10.9484 44.9534 10.0788 44.9421 9.19869L44.927 8.01756C44.9236 7.75525 44.9937 7.49724 45.1294 7.2727C45.265 7.04816 45.4608 6.86605 45.6945 6.74696C45.9283 6.62787 46.1907 6.57656 46.452 6.59882C46.7134 6.62108 46.9634 6.71603 47.1736 6.87294L48.1203 7.57944C48.8257 8.10589 49.6484 8.45292 50.5177 8.59064C51.387 8.72835 52.2767 8.65261 53.1102 8.36994L54.229 7.99044C54.4774 7.9062 54.7445 7.89316 54.9999 7.95278C55.2554 8.01239 55.4891 8.1423 55.6746 8.3278C55.8601 8.51329 55.99 8.74699 56.0496 9.00246C56.1092 9.25793 56.0962 9.52499 56.012 9.77344L55.6326 10.8921C55.3499 11.7256 55.2741 12.6154 55.4118 13.4847C55.5495 14.354 55.8966 15.1769 56.4231 15.8822L57.1295 16.8288C57.2864 17.039 57.3813 17.289 57.4036 17.5504C57.4258 17.8118 57.3745 18.0741 57.2554 18.3079C57.1364 18.5416 56.9542 18.7374 56.7297 18.873C56.5052 19.0087 56.2472 19.0788 55.9848 19.0754L54.8036 19.0603C53.9236 19.049 53.054 19.2518 52.2698 19.6513C51.4855 20.0509 50.8103 20.6351 50.3021 21.3537L49.62 22.3183C49.4685 22.5325 49.2601 22.7 49.0184 22.802C48.7767 22.9039 48.5113 22.9362 48.2522 22.8952C47.9931 22.8541 47.7507 22.7414 47.5523 22.5698C47.3539 22.3982 47.2075 22.1744 47.1296 21.9239L46.779 20.7959Z",
    fill: "url(#paint6_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6666 22.5794L41.4231 6.33594L41.4606 9.24319C41.4646 9.55867 41.3919 9.87041 41.2487 10.1516C41.1055 10.4327 40.8962 10.6748 40.6386 10.8571L34.8068 14.9812C34.5103 15.1909 34.2784 15.4793 34.1373 15.8139C33.9962 16.1485 33.9515 16.5159 34.0083 16.8746C34.0651 17.2333 34.2212 17.5689 34.4588 17.8435C34.6964 18.1181 35.0061 18.3208 35.3528 18.4286L42.1737 20.5488C42.475 20.6425 42.749 20.808 42.9721 21.0311C43.1952 21.2542 43.3607 21.5282 43.4543 21.8294L45.5746 28.6503C45.6824 28.9971 45.885 29.3068 46.1597 29.5444C46.4343 29.782 46.7699 29.938 47.1286 29.9948C47.4872 30.0516 47.8546 30.0069 48.1892 29.8658C48.5239 29.7247 48.8123 29.4928 49.022 29.1963L53.1461 23.3646C53.3283 23.1069 53.5704 22.8975 53.8515 22.7542C54.1327 22.6109 54.4444 22.5382 54.76 22.5422L57.6666 22.5794Z",
    fill: "url(#paint7_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9815 20.6615C17.1686 17.0946 14.1943 14.252 10.5489 12.6025C10.4586 12.5612 10.382 12.4948 10.3283 12.4112C10.2746 12.3276 10.2461 12.2304 10.2461 12.1311C10.2461 12.0317 10.2746 11.9345 10.3283 11.8509C10.382 11.7673 10.4586 11.7009 10.5489 11.6596C14.1943 10.01 17.1687 7.16729 18.9815 3.60025C19.0247 3.51488 19.0908 3.44315 19.1723 3.39304C19.2538 3.34293 19.3476 3.31641 19.4433 3.31641C19.539 3.31641 19.6328 3.34293 19.7143 3.39304C19.7958 3.44315 19.8618 3.51488 19.905 3.60025C21.7181 7.16739 24.6927 10.0101 28.3383 11.6596C28.4286 11.7009 28.5052 11.7673 28.5589 11.8509C28.6126 11.9345 28.6411 12.0317 28.6411 12.1311C28.6411 12.2304 28.6126 12.3276 28.5589 12.4112C28.5052 12.4948 28.4286 12.5612 28.3383 12.6025C24.693 14.252 21.7186 17.0946 19.9057 20.6615C19.8625 20.747 19.7965 20.8189 19.7149 20.8692C19.6333 20.9194 19.5394 20.946 19.4436 20.946C19.3478 20.946 19.2539 20.9194 19.1723 20.8692C19.0907 20.8189 19.0247 20.747 18.9815 20.6615Z",
    fill: "url(#paint8_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7408 30.5672C8.50082 28.1273 6.4663 26.1829 3.9728 25.0547C3.911 25.0265 3.85861 24.981 3.82188 24.9239C3.78515 24.8667 3.76563 24.8002 3.76562 24.7323C3.76563 24.6643 3.78515 24.5978 3.82188 24.5406C3.85861 24.4835 3.911 24.4381 3.9728 24.4098C6.46628 23.2815 8.50078 21.3371 9.7408 18.8973C9.77035 18.8389 9.81552 18.7898 9.87128 18.7556C9.92704 18.7213 9.99122 18.7031 10.0567 18.7031C10.1221 18.7031 10.1863 18.7213 10.2421 18.7556C10.2978 18.7898 10.343 18.8389 10.3726 18.8973C11.6127 21.3371 13.6471 23.2815 16.1406 24.4098C16.2024 24.4381 16.2547 24.4835 16.2915 24.5406C16.3282 24.5978 16.3477 24.6643 16.3477 24.7323C16.3477 24.8002 16.3282 24.8667 16.2915 24.9239C16.2547 24.981 16.2024 25.0265 16.1406 25.0547C13.6473 26.1831 11.613 28.1275 10.3732 30.5672C10.3437 30.6258 10.2985 30.675 10.2427 30.7094C10.1869 30.7438 10.1226 30.762 10.057 30.762C9.99141 30.762 9.92713 30.7438 9.8713 30.7094C9.81547 30.675 9.77029 30.6258 9.7408 30.5672Z",
    fill: "url(#paint9_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6275 48.3994C52.3875 45.9595 50.353 44.0151 47.8595 42.8868C47.7977 42.8586 47.7453 42.8132 47.7086 42.756C47.6719 42.6988 47.6523 42.6323 47.6523 42.5644C47.6523 42.4964 47.6719 42.4299 47.7086 42.3727C47.7453 42.3155 47.7977 42.2701 47.8595 42.2418C50.3529 41.1135 52.3874 39.1692 53.6275 36.7293C53.657 36.6709 53.7022 36.6219 53.758 36.5876C53.8137 36.5533 53.8779 36.5352 53.9434 36.5352C54.0088 36.5352 54.073 36.5533 54.1288 36.5876C54.1845 36.6219 54.2297 36.6709 54.2592 36.7293C55.4992 39.1692 57.5337 41.1136 60.0272 42.2418C60.089 42.2701 60.1414 42.3155 60.1781 42.3727C60.2148 42.4299 60.2344 42.4964 60.2344 42.5644C60.2344 42.6323 60.2148 42.6988 60.1781 42.756C60.1414 42.8132 60.089 42.8586 60.0272 42.8868C57.5337 44.0151 55.4992 45.9595 54.2592 48.3994C54.2297 48.4578 54.1845 48.5068 54.1288 48.5411C54.073 48.5754 54.0088 48.5935 53.9434 48.5935C53.8779 48.5935 53.8137 48.5754 53.758 48.5411C53.7022 48.5068 53.657 48.4578 53.6275 48.3994Z",
    fill: "url(#paint10_linear_6275_23317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5728 60.4891C33.3327 58.0493 31.2983 56.1049 28.8048 54.9766C28.743 54.9483 28.6906 54.9029 28.6539 54.8458C28.6172 54.7886 28.5977 54.7221 28.5977 54.6541C28.5977 54.5862 28.6172 54.5197 28.6539 54.4625C28.6906 54.4053 28.743 54.3599 28.8048 54.3317C31.2983 53.2033 33.3327 51.259 34.5728 48.8192C34.6024 48.7608 34.6475 48.7117 34.7033 48.6774C34.7591 48.6432 34.8233 48.625 34.8887 48.625C34.9542 48.625 35.0183 48.6432 35.0741 48.6774C35.1299 48.7117 35.175 48.7608 35.2046 48.8192C36.4446 51.259 38.479 53.2034 40.9725 54.3317C41.0343 54.3599 41.0867 54.4053 41.1235 54.4625C41.1603 54.5196 41.1798 54.5862 41.1798 54.6541C41.1798 54.7221 41.1603 54.7886 41.1235 54.8458C41.0867 54.903 41.0343 54.9484 40.9725 54.9766C38.479 56.1049 36.4446 58.0493 35.2046 60.4891C35.175 60.5475 35.1299 60.5965 35.0741 60.6308C35.0183 60.6651 34.9542 60.6833 34.8887 60.6833C34.8233 60.6833 34.7591 60.6651 34.7033 60.6308C34.6475 60.5965 34.6024 60.5475 34.5728 60.4891Z",
    fill: "url(#paint11_linear_6275_23317)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6275_23317",
    x1: 25.6463,
    y1: 35.9851,
    x2: 29.0548,
    y2: 39.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5CAF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6275_23317",
    x1: 38.9366,
    y1: 25.0622,
    x2: 46.578,
    y2: 17.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#5B3374",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#5B3374",
    stopOpacity: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5B3374",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#5B3374",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#5B3374",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6275_23317",
    x1: 9.69548,
    y1: 50.0533,
    x2: 14.0776,
    y2: 54.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5CAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD80E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6275_23317",
    x1: 13.5623,
    y1: 50.4363,
    x2: 20.6273,
    y2: 43.3713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#5B3374",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#5B3374",
    stopOpacity: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5B3374",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#5B3374",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#5B3374",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3374"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6275_23317",
    x1: 21.6049,
    y1: 42.3816,
    x2: 19.9168,
    y2: 44.0697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEFFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6275_23317",
    x1: 48.9249,
    y1: 5.87182,
    x2: 48.9249,
    y2: 26.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6275_23317",
    x1: 49.2485,
    y1: 22.826,
    x2: 49.2485,
    y2: 6.44568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6275_23317",
    x1: 47.081,
    y1: 16.9169,
    x2: 40.6534,
    y2: 23.3444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6275_23317",
    x1: 46.3693,
    y1: 14.4565,
    x2: 32.7246,
    y2: 28.1013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6275_23317",
    x1: 10.0567,
    y1: 20.6097,
    x2: 10.0567,
    y2: 33.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAEE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5694"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6275_23317",
    x1: 53.9434,
    y1: 38.442,
    x2: 53.9434,
    y2: 51.6431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6275_23317",
    x1: 35.9497,
    y1: 38.4248,
    x2: 45.2829,
    y2: 47.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEFFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22B27F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6275_23317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0c2874c703356c3f96badfb8dbacf39c.svg";
export { ForwardRef as ReactComponent };